import UISelect from 'UIComponents/input/UISelect';
import CampaignToAutoSelectPopover from './CampaignToAutoSelectPopover';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignSelectWithAutoSelectPopover({
  forceClose,
  hasDismissedPopover,
  onCampaignAutoSelectChange,
  setHasDismissedPopover,
  setValueFromAttributes,
  valueFromProps,
  withCampaignAutoSelectPopover,
  uiSelectProps
}) {
  const campaignSelect = /*#__PURE__*/_jsx(UISelect, Object.assign({}, uiSelectProps));
  return withCampaignAutoSelectPopover ? /*#__PURE__*/_jsx(CampaignToAutoSelectPopover, {
    forceClose: forceClose,
    hasDismissedPopover: hasDismissedPopover,
    onSelect: onCampaignAutoSelectChange,
    setHasDismissedPopover: setHasDismissedPopover,
    setValueFromAttributes: setValueFromAttributes,
    valueFromProps: valueFromProps,
    children: campaignSelect
  }) : campaignSelect;
}